import { createCleanupCallback25lsm9rsfgs13 as createCleanupCallback } from '../internal/createCleanupCallback.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function invoke(_this__u8e3s4, effect, dependencies) {
  var callback = createCleanupCallback(effect);
  _this__u8e3s4(callback, dependencies);
}
function invoke_0(_this__u8e3s4, effect) {
  var callback = createCleanupCallback(effect);
  _this__u8e3s4(callback);
}
//region block: exports
export {
  invoke as invoke3e9ytlmskvi4s,
  invoke_0 as invoke2ywiw9ln9yogo,
};
//endregion

//# sourceMappingURL=EffectHook.mjs.map
